// extracted by mini-css-extract-plugin
module.exports = {"actions-coulumn":"index__actions-coulumn__2uHQv","btn-add":"index__btn-add__2aw48","checkboxHeader":"index__checkboxHeader__2fYll"};